// =====================================================================
// commande-prete/droits.js — Commandes prêtes : droits PROPRES au module (SPEC v3 D, 17-10-2026)
// =====================================================================
// Décision Silviu 17/10 : le module n'emprunte plus les droits de « Dimensions & poids ». Catégorie
// `commandes_pretes` (écran Permissions → « 📦 Commandes prêtes »), 5 droits — MÊMES identifiants que le
// serveur (backend/src/services/ready-droits.js ; un test vérifie qu'ils sont identiques) :
//   lire      commandes_pretes.read.own    tuile, pastille, page Commandes prêtes, écran d'une commande
//   encoder   commandes_pretes.encode.own  « ＋ Nouvelle commande », écran d'encodage MODIFIABLE (sinon lecture
//                                          seule, dit clairement), supprimer un brouillon
//   charger   commandes_pretes.load.own    « 🚚 Chargement » et sa page
//   imprimer  commandes_pretes.print.own   « Imprimer », « Marquer imprimé », « Vu » d'un rendez-vous
//   admin     commandes_pretes.admin.all   « ⚙ Paramètres clients », case « Commande de test », envoi « à
//                                          vérifier », reprise de la facturation
// `admin` vaut TOUJOURS aussi chaque droit (comme le serveur). L'écran ne fait que montrer ou cacher : le
// serveur refuse de toute façon (403 « Droit manquant : … »).
// Fonctions PURES (aucun DOM) : testées par frontend/test/commande-prete.test.mjs.
// =====================================================================

export const DROIT_LIRE = 'commandes_pretes.read.own';
export const DROIT_ENCODER = 'commandes_pretes.encode.own';
export const DROIT_CHARGER = 'commandes_pretes.load.own';
export const DROIT_IMPRIMER = 'commandes_pretes.print.own';
export const DROIT_ADMIN = 'commandes_pretes.admin.all';
export const DROITS_COMMANDES_PRETES = Object.freeze([DROIT_LIRE, DROIT_ENCODER, DROIT_CHARGER, DROIT_IMPRIMER, DROIT_ADMIN]);

export const LIBELLES_DROITS = Object.freeze({
  [DROIT_LIRE]: 'Voir les commandes prêtes',
  [DROIT_ENCODER]: 'Encoder et envoyer',
  [DROIT_CHARGER]: 'Charger un camion',
  [DROIT_IMPRIMER]: 'Imprimer les documents',
  [DROIT_ADMIN]: 'Administrer les commandes prêtes',
});

/** Ce que la personne peut faire dans le module, d'après `can` (useAuth) : { lire, encoder, charger, imprimer, admin }. */
export function droitsCommandesPretes(can) {
  const a = (id) => typeof can === 'function' && can(id) === true;
  const admin = a(DROIT_ADMIN);
  // Même règle que le serveur (exigeDroit) : sans « Voir » (ou l'admin), rien ; un droit d'action s'y ajoute.
  const lire = admin || a(DROIT_LIRE);
  return {
    lire,
    encoder: lire && (admin || a(DROIT_ENCODER)),
    charger: lire && (admin || a(DROIT_CHARGER)),
    imprimer: lire && (admin || a(DROIT_IMPRIMER)),
    admin,
  };
}

/** Page fermée faute de droit : le droit qui manque, en clair. */
export const texteAccesRefuse = (droit) => (droit === DROIT_ADMIN
  ? `Accès réservé aux administrateurs du module (droit « ${LIBELLES_DROITS[DROIT_ADMIN]} »).`
  : `Accès réservé : droit « ${LIBELLES_DROITS[droit] || LIBELLES_DROITS[DROIT_LIRE]} » (module Commandes prêtes) — demandez-le à un administrateur.`);

/** Bandeau de l'écran d'une commande ouvert sans « Encoder et envoyer ». */
export const MSG_LECTURE_SEULE = `Lecture seule : vous pouvez voir cette commande, pas la modifier (droit « ${LIBELLES_DROITS[DROIT_ENCODER]} »)`;
/** Note sous le bouton d'envoi, en lecture seule (à la place des consignes de saisie, qui ne la concernent pas). */
export const NOTE_ENVOI_LECTURE_SEULE = `Envoi du mail réservé au droit « ${LIBELLES_DROITS[DROIT_ENCODER]} ».`;
